import React, { useCallback } from "react";
import styles from "./nodeTypeComponents.module.css";
import { LoadingOutlined } from "@ant-design/icons";
import { throttle } from "lodash";

const LoadMore = ({ noMore = true, onClick = () => {}, loading = false }) => {
  const handleClickLoadMore = useCallback(
    throttle(
      () => {
        onClick();
      },
      5000,
      { trailing: false }
    ),
    [onClick]
  );

  return (
    <div className={styles.loadMore}>
      {noMore ? (
        <div>No more</div>
      ) : (
        <div onClick={handleClickLoadMore}>Load more {loading && <LoadingOutlined />}</div>
      )}
    </div>
  );
};

export default LoadMore;
